import { Text, Stack, VStack } from '@genial/components';
import { BoxRadius, Spacing, Typography } from '@genial/design-tokens';
import { Utils, useBreakpointValue } from '@genial/utils';
import React from 'react';
import { useRecoilValue } from 'recoil';

import { productsCartState } from '../../../../../../store/batchTicket/atom';
import { customerCartEstimatedBalanceSelector } from '../../../../../../store/batchTicket/selectors';
import { useCustomersAdded } from '../../../../hooks/customersAdded';
import { hasAnyItems } from '../../../Customer/components/Selected';

interface CustomersResumeCartProps {}

export const CustomersResumeCart: React.FC<CustomersResumeCartProps> = () => {
  const isMobile = useBreakpointValue({ base: true, sm: false });
  const { customerCartTotalAvailableBalance, customerCartCount } = useCustomersAdded();

  const productsCartList = useRecoilValue(productsCartState);
  const customerCartEstimatedBalance = useRecoilValue(customerCartEstimatedBalanceSelector);
  const showEstimatedValue = hasAnyItems(productsCartList);

  const textVariant = isMobile ? 'regular' : 'bold';

  return (
    <Stack
      direction={{ base: 'column', sm: 'row' }}
      space={{ base: Spacing['stack.nano'] }}
      px={Spacing['inline.xxs']}
      py={Spacing['inline.xxxs']}
      borderRadius={BoxRadius.sm}
      alignItems="center"
      justifyContent="space-between"
      bgColor={Utils.ColorToken.WithOpacity('brand.tertiary.lightest', 0.3)}>
      <Stack
        space={Spacing['inline.nano']}
        direction={{ base: 'row', sm: 'column' }}
        alignItems={{ base: 'center', sm: 'flex-start' }}
        justifyContent="space-between"
        w={{ base: 'full', sm: 'container' }}>
        <Text variant={textVariant} fontSize={Typography['fontsize.md']} color="neutral.darkest">
          Clientes adicionados
        </Text>
        <Text variant="regular" fontSize={Typography['fontsize.md']} color="neutral.black">
          {customerCartCount} clientes
        </Text>
      </Stack>
      <Stack
        direction={{ base: 'column', sm: 'row' }}
        alignItems="center"
        justifyContent="space-between"
        w={{ base: 'full', sm: 'container' }}
        space={{ base: Spacing['inline.nano'], sm: Spacing['inline.xs'] }}>
        <Stack
          direction={{ base: 'row', sm: 'column' }}
          justifyContent="space-between"
          w={{ base: 'full', sm: 'container' }}
          space={Spacing['inline.quarck']}
          alignItems="flex-end">
          <Text variant={textVariant} fontSize={Typography['fontsize.md']} color="neutral.black">
            Total disponível
          </Text>
          <Text variant="regular" fontSize={Typography['fontsize.md']} color="neutral.black">
            {customerCartTotalAvailableBalance.totalFormatted}
          </Text>
        </Stack>
        <VStack
          direction={{ base: 'row', sm: 'column' }}
          w={{ base: 'full', sm: 'container' }}
          space={Spacing['inline.quarck']}
          justifyContent="space-between"
          alignItems="flex-end">
          <Text variant={textVariant} fontSize={Typography['fontsize.md']} color="neutral.darkest">
            Total estimado
          </Text>
          <Text variant="regular" fontSize={Typography['fontsize.md']} color="neutral.darkest">
            {showEstimatedValue
              ? customerCartEstimatedBalance.totalFormatted
              : 'Adicione os produtos'}
          </Text>
          {!isMobile && (
            <Text variant="regular" fontSize={Typography['fontsize.xs']} color="neutral.medium">
              Após investimento
            </Text>
          )}
        </VStack>
      </Stack>
    </Stack>
  );
};
